import * as Sentry from "@sentry/react";

import { useErrorToast } from "@/hooks/useErrorToast";

export function useReportUnexpectedNull() {
  const errorToast = useErrorToast();

  return (context: string, variable: string, showToast = true) => {
    const message = `Unexpected null: ${variable} in ${context}`;

    console.error(message);
    Sentry.captureMessage(message, "error");

    if (showToast) {
      errorToast({ description: message });
    }
  };
}
